var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5C3.582 0.5 0 4.082 0 8.5C0 12.918 3.582 16.5 8 16.5C12.418 16.5 16 12.918 16 8.5C16 4.082 12.418 0.5 8 0.5ZM7.00025 12.5006C6.73625 12.5006 6.48125 12.3966 6.29325 12.2076L4.29325 10.2076C3.90225 9.81657 3.90225 9.18457 4.29325 8.79357C4.68425 8.40257 5.31625 8.40257 5.70725 8.79357L6.84525 9.93157L10.1683 4.94557C10.4742 4.48557 11.0942 4.36157 11.5553 4.66857C12.0142 4.97557 12.1383 5.59557 11.8323 6.05557L7.83225 12.0556C7.66625 12.3046 7.39625 12.4666 7.09925 12.4956C7.06525 12.4986 7.03325 12.5006 7.00025 12.5006Z",
    fill: "#7256CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/AlertSuccess.586a263658e2ba0701488f0434eda924.svg";
export { ForwardRef as ReactComponent };